
































import { Component, Vue } from "vue-property-decorator";
import request from "@/api/index";
import { INews } from "@/api/types";
import { List } from "vant";
import { ColumnInfo2024 } from "@/common/baseConfig";
@Component({
  components: {
    "van-list": List
  }
})
export default class Home extends Vue {
  /** 视频新闻列表 */
  videoList: INews[] = [];

  maskList: boolean[] = [];

  loading = false;
  finished = false;

  mounted() {}

  onLoad() {
    setTimeout(() => {
      this.getVideoList();
    }, 300);
  }

  /** 视频新闻 */
  async getVideoList() {
    const lastItem = this.videoList[this.videoList.length - 1] || {};
    const result = await request.getInfoList(
      ColumnInfo2024.视频新闻,
      lastItem.id,
      lastItem.sortNo,
      lastItem.onlineTime
    );
    if (!result.code) {
      result.data.news.forEach(item => {
        item.showMask = true;
      });
      if (!result.data || result.data.news.length === 0) {
        this.finished = true;
      } else {
        this.loading = false;
        this.videoList = this.videoList.concat(result.data.news);
      }
    }
  }

  /** 播放视频 */
  playVideo(index: number) {
    const videos: HTMLVideoElement[] = this.$refs.video as HTMLVideoElement[];
    videos.forEach(it => {
      it.pause();
    });
    this.videoList.forEach(it => {
      it.showMask = true;
    });
    this.videoList[index].showMask = false;
    videos[index].play();
  }

  newsClick(data: INews) {
    window.location.href = data.url;
  }
}
